import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text, IconImage } from "braid-design-system";
import { FileUploader } from "../private/FileUploader/FileUploader.mjs";
import { root } from "./UploadAssetButton.css.mjs";
const UploadAssetButton = ({
  label,
  dataTestId = "bx-upload-asset",
  onClick,
  onFileSelected
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    className: root,
    "data-testid": `${dataTestId}-button`,
    onClick,
    children: [
      /* @__PURE__ */ jsx(Text, { tone: "secondary", icon: /* @__PURE__ */ jsx(IconImage, {}), size: "small", align: "center", children: label }),
      /* @__PURE__ */ jsx(
        FileUploader,
        {
          dataTestId: `${dataTestId}-input`,
          onFileSelected
        }
      )
    ]
  }
);
export {
  UploadAssetButton
};
